import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromSystem from './system.reducer';

const selectSystemState = createFeatureSelector<fromSystem.State>('system');

export const selectTenantConfig = createSelector(
  selectSystemState,
  fromSystem.getTenantConfig
);
